import { Console } from "console";
import { getAnalyticsApiUrl } from "../../constants/Urls";
import DatedUsageModel from "../../models/analytics/api/DatedUsageModel";
import { sendGet } from "./generic";

export const getConversationalSuccessHistogram = (applicationId: string, startDate: string, endDate: string, interval: number, categories: string[], tags: string[]) => {
    let url = `/ApplicationAnalytics/conversationalSuccess/histogram/${applicationId}?interval=${interval}&startDate=${startDate}&endDate=${endDate}`;
    if (categories && categories.length > 0) {
        categories.forEach(cat =>
            url += `&categories=${cat}`
        )

    }
    if (tags && tags.length > 0) {
        tags.forEach(tag =>
            url += `&tags=${tag}`
        )
    }
    url += `&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`;

    return sendGet<DatedUsageModel[]>(url, getAnalyticsApiUrl());
};
